import React, { useEffect, useState } from 'react';

// custom components
import { } from '_atoms';
import { } from '_molecules';
import { } from '_organisms';

// nav
import { useHistory } from 'react-router-dom';


// redux
import { useSelector, useDispatch, } from 'react-redux';
import { logout, getDbInfo, selectFirebaseUser, selectUserDb, reset, resetStatus } from '_redux/slices/main-screen/user';
import { reset as HistoryReset } from '_redux/slices/assistance-bookings/bookings-history';
import { reset as TableReset } from '_redux/slices/prm-bookings/bookings-table';
import { reset as BookingsReset } from '_redux/slices/prm-bookings/bookings';
import { reset as CalendarReset } from '_redux/slices/prm-bookings/calendar';
import { reset as ScreenReset } from '_redux/slices/main-screen/render-screen';
import { reset as ReviewsReset } from '_redux/slices/analytics/reviews';
import { reset as RewardsReset } from '_redux/slices/prm-club/rewards';
import { reset as UserBookingsReset } from '_redux/slices/website/userbookings';
//timeline reducers
import { reset as EmployeeReset } from '_redux/slices/timeline/employees';
import { reset as FlightScannerReset } from '_redux/slices/timeline/flight-scanner';
import { reset as SelectedTaskReset } from '_redux/slices/timeline/selected-task';
import { reset as TimelineAreaReset } from '_redux/slices/timeline/timeline-areas';
import { reset as TimelineDataReset } from '_redux/slices/timeline/timeline-data';
import { reset as resetTimeLineControl } from "_redux/slices/timeline/timeline-control";
import { reset as resetTimeLineDashboard } from "_redux/slices/timeline/timeline-dashboard";
//websites reducers
import { reset as ContactReset } from '_redux/slices/website/contact';
import { reset as TransactionsReset } from '_redux/slices/website/transactions';
import { reset as QrHandlerReset } from '_redux/slices/website/qr-handler';
//messages reducers
import { reset as MessagingReset } from '_redux/slices/messaging/messaging';
import { reset as resetTimelineReports } from '_redux/slices/timeline-reports/timeline-reports';

// utils
import { Colors, Spacing, Typography } from '_styles';

const Logout = (props) => {

    const dispatch = useDispatch();

    // nav
    const history = useHistory();

    // logout 
    const handleLogout = () => {
        // logout and change page
        dispatch(logout());
        //history.push('/login');

        // reset all slices
        dispatch(resetStatus());
        dispatch(reset())
        dispatch(HistoryReset())
        dispatch(TableReset())
        dispatch(BookingsReset())
        dispatch(CalendarReset())
        dispatch(ScreenReset())
        dispatch(ReviewsReset())
        dispatch(RewardsReset())
        dispatch(UserBookingsReset())
        dispatch(EmployeeReset());
        dispatch(FlightScannerReset());
        dispatch(SelectedTaskReset());
        dispatch(TimelineAreaReset());
        dispatch(TimelineDataReset());
        dispatch(resetTimeLineControl());
        dispatch(resetTimeLineDashboard());
        dispatch(ContactReset());
        dispatch(TransactionsReset());
        dispatch(QrHandlerReset());
        dispatch(HistoryReset())
        dispatch(TableReset())
        dispatch(BookingsReset())
        dispatch(CalendarReset())
        dispatch(ScreenReset())
        dispatch(ReviewsReset())
        dispatch(RewardsReset())
        dispatch(UserBookingsReset())
        dispatch(MessagingReset())
        dispatch(resetTimelineReports())
    }

    useEffect(() => {
        handleLogout()
    }, []);

    return (
        <p>Logging out...</p>
    );
};

export default Logout;